"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shadowSelector = shadowSelector;

function shadowSelector(props, intensity) {
  var _props$theme, _props$theme$shadows;

  return (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$shadows = _props$theme.shadows) === null || _props$theme$shadows === void 0 ? void 0 : _props$theme$shadows["$".concat(intensity, "dp")];
}